import * as angular from 'angular';
import template from './gobWeightsGraph.tpl.html';
import controller from './gobWeightsGraph.controller';

export default angular.module('aps.directive.gobWeightsGraph', [controller])
  .directive('apsGobWeightsGraph', gobWeightsGraphDef)
  .name;

function gobWeightsGraphDef() {
  return {
    restrict: 'E',
    template: template,
    replace: true,
    controller: 'GobWeightsGraphCtrl',
    controllerAs: 'vm',
    bindToController: true,
    scope: {
      shopId: '=',
      width: '@?',
      height: '@?',
      isScaleButtonVisible: '=?',
      hoursToShow: '=?'
    }
  };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/controllers/dashboard/gobWeightsGraph.directive.ts